/**
 * Kalkulator WHR: czysta logika obliczeń.
 *
 * Zero DOM, zero zależności. Ten sam plik działa w przeglądarce
 * (window.DnnzWhrLogic) i w Node (module.exports). Liczby (progi, zakresy
 * pól) przychodzą z konfiguracji inc/data/whr.php.
 *
 * WHR = obwód talii / obwód bioder, zaokrąglony do 0,01 (połówki w górę).
 * Wynik prawidłowy: WHR do progu włącznie (0,85 kobiety, 0,9 mężczyźni).
 */
(function (root, factory) {
	'use strict';
	var api = factory();
	// Oba wyjścia naraz: przy budowaniu webpackiem istnieje "module", a skrypt
	// bloku i tak szuka logiki w window, więc globalna nazwa musi powstać zawsze.
	if (typeof module === 'object' && module.exports) {
		module.exports = api;
	}
	if (root) {
		root.DnnzWhrLogic = api;
	}
}(typeof window !== 'undefined' ? window : null, function () {
	'use strict';

	function toNumber(value) {
		if (value === null || value === '' || typeof value === 'undefined') {
			return NaN;
		}
		var parsed = Number(String(value).trim().replace(',', '.'));
		return isFinite(parsed) ? parsed : NaN;
	}

	/**
	 * Ucina śmieci zmiennoprzecinkowe przed zaokrągleniem (jak round_half_up()
	 * w klasie bloku): 0,29 × 100 to w IEEE 754 28,999999999999996.
	 */
	function round6(value) {
		return Math.round(value * 1e6) / 1e6;
	}

	/**
	 * WHR w setnych (liczba całkowita): 87 = 0,87. Porównania idą na liczbach
	 * całkowitych, żeby nie zależeć od zapisu zmiennoprzecinkowego.
	 */
	function whrHundredths(waist, hip) {
		return Math.round(round6((waist / hip) * 100));
	}

	/** Zapis z przecinkiem i dwoma miejscami: 87 → "0,87", 100 → "1,00". */
	function formatWhr(hundredths) {
		var whole = Math.floor(hundredths / 100);
		var frac = hundredths % 100;
		return whole + ',' + (frac < 10 ? '0' : '') + frac;
	}

	/**
	 * Odczyt pola w cm: { value, empty, invalid }. Puste pole to osobny stan,
	 * nie błąd. Błąd: tekst, który nie jest liczbą z zakresu pola.
	 */
	function readField(raw, limits) {
		var text = raw === null || typeof raw === 'undefined' ? '' : String(raw).trim();
		if (text === '') {
			return { value: null, empty: true, invalid: false };
		}
		var value = toNumber(text);
		if (isNaN(value) || value < limits.min || value > limits.max) {
			return { value: null, empty: false, invalid: true };
		}
		return { value: value, empty: false, invalid: false };
	}

	/** Próg w setnych: 0,85 → 85. */
	function thresholdHundredths(sex, cfg) {
		return Math.round(round6(cfg.thresholds[sex] * 100));
	}

	function category(hundredths, sex, cfg) {
		return hundredths <= thresholdHundredths(sex, cfg) ? 'normal' : 'high';
	}

	/**
	 * input: { sex ('k' | 'm' | ''), waist, hip (teksty pól) }.
	 * Wynik pojawia się dopiero przy obu obwodach i wybranej płci.
	 */
	function evaluate(input, cfg) {
		var waist = readField(input.waist, cfg.valid.waist);
		var hip = readField(input.hip, cfg.valid.hip);
		var sex = input.sex === 'k' || input.sex === 'm' ? input.sex : '';
		var measured = waist.value !== null && hip.value !== null;

		var state = {
			fields: { waist: waist, hip: hip },
			sex: sex,
			sexMissing: measured && sex === '',
			hasResult: measured && sex !== '',
			hundredths: null,
			whr: null,
			category: null,
			threshold: sex ? cfg.thresholds[sex] : null
		};

		if (state.hasResult) {
			state.hundredths = whrHundredths(waist.value, hip.value);
			state.whr = formatWhr(state.hundredths);
			state.category = category(state.hundredths, sex, cfg);
		}

		return state;
	}

	/** Tabelka przykładów: WHR i kategoria dla każdego przykładu z konfiguracji. */
	function samples(cfg) {
		return cfg.samples.map(function (s) {
			var h = whrHundredths(s.waist, s.hip);
			return { sample: s, hundredths: h, whr: formatWhr(h), category: category(h, s.sex, cfg) };
		});
	}

	return {
		toNumber: toNumber,
		round6: round6,
		whrHundredths: whrHundredths,
		formatWhr: formatWhr,
		readField: readField,
		thresholdHundredths: thresholdHundredths,
		category: category,
		evaluate: evaluate,
		samples: samples
	};
}));
